/* eslint-disable */
import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DialogModal from '../../../components/modal/DialogModal';

export default function ProctoringWarningModal({ open, violationCount, violationType, onClose, maxViolations = 3 }) {
  const remaining = maxViolations - violationCount;
  const isFinal = remaining <= 0;

  const messages = {
    TAB_SWITCH: 'You switched away from the exam tab.',
    WINDOW_BLUR: 'You left the exam window.',
    NO_FACE: 'Your face is not visible to the camera.',
    MULTIPLE_FACES: 'Multiple faces detected. Only the student should be visible.',
  };

  return (
    <DialogModal open={open} handleClose={onClose} title={isFinal ? 'Exam Auto-Submitted' : `Warning ${violationCount}/${maxViolations}`} maxWidth="xs">
      <Box sx={{ textAlign: 'center', py: 2 }}>
        <Box sx={{ width: 60, height: 60, borderRadius: '50%', bgcolor: isFinal ? '#fee2e2' : '#fef3c7', display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2 }}>
          <WarningAmberIcon sx={{ fontSize: 32, color: isFinal ? '#dc2626' : '#d97706' }} />
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {messages[violationType] || 'A proctoring violation was detected.'}
        </Typography>
        {!isFinal && (
          <Typography variant="body2" sx={{ color: '#dc2626', fontWeight: 600 }}>
            {remaining === 1 ? '⚠️ Next violation will auto-submit your exam!' : `You have ${remaining} warning(s) remaining.`}
          </Typography>
        )}
        {isFinal && (
          <Typography variant="body2" color="error" fontWeight={600}>
            Your exam has been automatically submitted due to repeated violations.
          </Typography>
        )}
        <Button variant="contained" onClick={onClose} sx={{ mt: 3, bgcolor: isFinal ? '#dc2626' : '#7c3aed', '&:hover': { bgcolor: isFinal ? '#b91c1c' : '#6d28d9' }, borderRadius: 2, px: 4 }}>
          {isFinal ? 'Close' : 'Continue Exam'}
        </Button>
      </Box>
    </DialogModal>
  );
}
